import { useMemo } from 'react';

import { getClientStore } from '../state';

export function useClientStore() {
  return useMemo(() => getClientStore(), []);
}
